
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/parkings/[city]",
      function () {
        return require("private-next-pages/parkings/[city]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/parkings/[city]"])
      });
    }
  